import script from "./EntityDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__